export default __webpack_public_path__ + "static/media/cablecat.48333f5f.jpg";